import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Form from '../Form';
import ModalContext from '../../modal/ModalContext';

const getLayout = fields => {
  const layout = [];
  Object.keys(fields).forEach(fieldName => {
    const field = fields[fieldName];
    const filterField = {};

    if (field.hidden) {
      return;
    }

    // TODO Support Tags
    if (field.control.toLowerCase() === 'button' || /^tags/.test(field.control.toLowerCase())) {
      return;
    }

    if (field.control.toLowerCase() === 'checkbox') {
      filterField.control = 'select';
    } else {
      filterField.control = field.control;
    }

    if (filterField.control.toLowerCase() === 'select') {
      filterField.options = field.options.map(o => o);
    }

    filterField.col = 6;
    filterField.type = field.type;
    filterField.name = field.name;
    filterField.label = field.label;
    filterField.validation = field.validation;
    filterField.data = '';
    layout.push(filterField);
  });

  return layout;
};

const FormTableFilter = props => {
  const { collection, handleApply } = props;
  const { close } = useContext(ModalContext);
  const layout = getLayout(collection);
  const filterKey = Math.random()
    .toString(36)
    .substring(8);

  const submit = payload => {
    const result = {};

    payload.forEach(field => {
      result[field.name] = field.data;
    });

    handleApply(result);
    close();
  };

  return (
    <Form layout={layout} submit={submit} onCancel={close} useDirtyWarning={false} usePrefix={filterKey} />
  );
};

FormTableFilter.defaultProps = {
  collection: {},
  handleApply: () => {},
};

FormTableFilter.propTypes = {
  collection: PropTypes.object,
  handleApply: PropTypes.func,
};

export default FormTableFilter;
